/**
 * External Dependencies
 */
 import 'jquery';

 // import local dependencies
 import Router from './util/Router';
 import common from './routes/common';
 import home from './routes/home';
 import blog from './routes/blog';
 
 /** Populate Router instance with DOM routes */
 const routes = new Router({
   // All pages
   common,
   home,
   blog,
 });
 
 window.onload = () => {
   routes.loadEvents();
 }